export enum TrackingVideoSource {
    Default = 'Default',
    Grid = 'Event List Video Icon',
    EventDetails = 'Event Details',
    EventSwitcher = 'Media Module Events Selector',
    MediaColumn = 'Media Module Video Play Icon',
    VideoPlay = 'Play Button',
    ShowcaseModule = 'Showcase Play Button',
}
